var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7713 28.7786C15.2748 28.9701 14.7249 28.9701 14.2284 28.7786C10.3513 27.2584 7.02228 24.6051 4.67532 21.165C2.32837 17.7248 1.07244 13.6573 1.07129 9.49284V3.21427C1.07129 2.64594 1.29705 2.1009 1.69892 1.69904C2.10078 1.29718 2.64582 1.07141 3.21415 1.07141H26.7856C27.3539 1.07141 27.899 1.29718 28.3008 1.69904C28.7026 2.1009 28.9284 2.64594 28.9284 3.21427V9.47141C28.9316 13.6395 27.6776 17.7117 25.3304 21.1561C22.9833 24.6006 19.6518 27.2569 15.7713 28.7786Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 22.9937C7.99857 20.1125 11.2776 18.2142 14.9999 18.2142C18.7222 18.2142 22.0012 20.1124 23.9216 22.9937",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 15C17.6629 15 19.8216 12.8414 19.8216 10.1786C19.8216 7.51581 17.6629 5.35718 15.0001 5.35718C12.3373 5.35718 10.1787 7.51581 10.1787 10.1786C10.1787 12.8414 12.3373 15 15.0001 15Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4d2de00106f3a58de2a10afb61aab8e1.svg";
export { ForwardRef as ReactComponent };